import type { CreateTypePropertyInput, UpdateTypePropertyInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import {
  createTypeProperty,
  deleteTypeProperty,
  updateTypeProperty
} from '../services/type-properties-admin.service'

export const useCreateTypePropertyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreateTypePropertyInput) => await createTypeProperty(payload),
    onSuccess: () => {
      toast.success('Subtipo creado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.typeProperties.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useUpdateTypePropertyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateTypePropertyInput }) =>
      await updateTypeProperty(id, payload),
    onSuccess: () => {
      toast.success('Subtipo actualizado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.typeProperties.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteTypePropertyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteTypeProperty(id),
    onSuccess: () => {
      toast.success('Subtipo eliminado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.typeProperties.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
